
import * as React from 'react';
import GroupEntriesView from './entries.view';
import { ContextService } from 'src/core/services/context.service';
import { observer } from 'mobx-react';
import { DataService } from 'src/core/services/data.service';
import { DataLocalService } from 'src/core/services/data-local.service';
import { observable } from 'mobx';
import { BookemZulu } from 'src/core/services/data/JayDataContext';
import { resolve } from 'inversify-react';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';

type QuoteItemW = BookemZulu.Bookings.Logic.ViewModels.QuoteItem;

interface IGroupEntriesControllerProps {
	contextService: ContextService;
	groupId: number;
	onDataLoad: (count: number) => void;
	setBusy: (isBusy: boolean) => void;
}

interface IGroupEntriesControllerState {

}

@observer
export default class GroupEntriesController extends React.Component<IGroupEntriesControllerProps, IGroupEntriesControllerState>{

	@observable
	dataService: DataSet<QuoteItemW>;

	@resolve
	toastService: ToastNotifications;

	componentDidMount() {
		this.loadEntries();
	}

	loadEntries = async () => {

		this.props.setBusy(true);

		try {
			console.log(this.props.groupId);
			const data = await (await this.props.contextService.current()).GetGroupReservations(this.props.groupId);

			this.dataService = new DataLocalService(await data.toArray(), 50);;

			this.props.onDataLoad(this.dataService.count);
		}
		catch (e) {
			this.toastService.showToast("Error", ObjectUtils.parseError(e), "error");
		}
		finally {
			this.props.setBusy(false);
		}
	}

	render() {

		if (!this.dataService || !this.dataService.item)
			return null;

		return <GroupEntriesView
				{...this.props}
				reload={this.loadEntries}
				dataService={this.dataService}
		/>;
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/entries.controller.tsx